import { render, staticRenderFns } from "./RegulatorSimple.vue?vue&type=template&id=1dac7846&"
import script from "./RegulatorSimple.vue?vue&type=script&lang=js&"
export * from "./RegulatorSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports